var render = function render(){var _vm=this,_c=_vm._self._c;return _c('custom-modal',{attrs:{"width":1180,"title":"项目列表","visible":_vm.visible,"footer":null},on:{"on-close":_vm.handleClose}},[_c('modal-content')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }